import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import type { Stripe, StripeElements, StripeElementsOptions } from "@stripe/stripe-js";
import { useEffect } from "react";

type ReadyCallback = (stripe: Stripe, elements: StripeElements) => void;

function PaymentForm({
  onReady,
  onLoadError,
}: {
  onReady: ReadyCallback;
  onLoadError: () => void;
}) {
  const stripe = useStripe();
  const elements = useElements();

  useEffect(() => {
    if (stripe && elements) onReady(stripe, elements);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripe, elements]);

  return <PaymentElement onLoadError={onLoadError} />;
}

export function StripePaymentElement({
  stripePromise,
  options,
  onReady,
  onLoadError,
}: {
  stripePromise: Promise<Stripe | null>;
  options: StripeElementsOptions;
  onReady: ReadyCallback;
  onLoadError: () => void;
}) {
  return (
    <Elements stripe={stripePromise} options={options}>
      <PaymentForm onReady={onReady} onLoadError={onLoadError} />
    </Elements>
  );
}
